export enum BonusActions {
  AX_DRAWER_SHOW = "AX_DRAWER_SHOW",
  AX_DRAWER_CLOSE = "AX_DRAWER_CLOSE",
  AX_DRAWER_DEFINITIONS_LOADED = "AX_DRAWER_DEFINITIONS_LOADED",
  AX_DRAWER_TOGGLE_UPSELL = "AX_DRAWER_TOGGLE_UPSELL",
  AX_DRAWER_TOGGLE_BUNDLE = "AX_DRAWER_TOGGLE_BUNDLE",
  MINI_CART_OPEN = "MINI_CART_OPEN",
  MINI_CART_CLOSE = "MINI_CART_CLOSE",
  BACK_TO_SHOP_URL_SET = "BACK_TO_SHOP_URL_SET",
}
